module.exports = __webpack_public_path__ + "img/left-arrow.ab75db35.svg";